export const categories = [
  {
    slug: "ledbary",
    nazev: "LEDBARY",
    perex: "Profesionální LED bary pro rovnoměrné a efektivní prozáření světelných boxů.",
    seo: {
      title: "LEDBARY – LED osvětlení pro světelné boxy | LightWell",
      description: "Profesionální LED bary pro světelnou reklamu, světelné boxy a reklamní panely."
    }
  },
  {
    slug: "zdroje",
    nazev: "Napájecí zdroje",
    perex: "Kompaktní napájecí zdroje 12V a 24V pro LED systémy - řada HHE s hliníkovým pouzdrem a řada HHX v ultra tenkém profilu.",
    seo: {
      title: "Napájecí zdroje HHE a HHX - 12V/24V pro LED | LightWell",
      description: "Napájecí zdroje 12V a 24V pro LED pásy a světelnou reklamu. Výkony 50-400W, DIP stmívání, postupný náběh, rychlospojovací svorky. Záruka 3 roky."
    }
  }
];